import { Component, OnInit, Input } from '@angular/core';
import { ToasterService } from 'angular2-toaster';
import swal from 'sweetalert2';
import { AiSettingsService } from '../../../services/index';

@Component({
    selector: 'ai-settings-tab',
    templateUrl: './aiSettings.component.html',
})
export class AiSettingsMasterComponent implements OnInit {
    @Input('tabTitle') title: string;
    @Input() active = false;
    @Input() isCloseable = false;
    @Input() dataContext;

    isLoading = false;
    isLoadMask: Promise<any>;

    settings: any = {
        call_trigger_start_time: '',
        call_trigger_end_time: ''
    };

    constructor(
        private aiSettingsService: AiSettingsService,
        private toasterService: ToasterService
    ) {}

    ngOnInit() {
        this.loadSettings();
    }

    loadSettings() {
        this.isLoadMask = this.aiSettingsService.getSettings().then((res: any) => {
            if (res.success) {
                this.settings = Object.assign(this.settings, res.data);
            }
        });
    }

    onSave() {
        this.isLoading = true;
        this.aiSettingsService.save(this.settings).then((res: any) => {
            this.isLoading = false;
            if (res.success) {
                swal('SUCCESS', res.message, 'success');
            } else {
                this.toasterService.pop({ type: 'error', title: 'ERROR', body: res.message });
            }
        });
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/master/aiSettings/aiSettings.component.ts